// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Card that sits under the shipment notes and exposes a button to open the
 * shipment audit log in a drawer. The audit events load lazily when the drawer
 * is opened.
 */
import { HistoryOutlined } from '@/constants/hardfin-standard-icons';
import { useDisclosure } from '@/hooks/use-disclosure';
import { ShipmentAuditDrawer } from '@/shipment/components/shipment-audit-drawer';
import { Button, Paper } from '@mui/material';

interface Props {
  shipmentKey: string;
}

export function ShipmentAuditCard(props: Props) {
  const drawer = useDisclosure();

  return (
    <Paper variant="outlined" sx={{ padding: 2 }}>
      <Button
        fullWidth
        size="small"
        startIcon={<HistoryOutlined />}
        onClick={drawer.open}
      >
        View audit log
      </Button>
      <ShipmentAuditDrawer
        shipmentKey={props.shipmentKey}
        disclosure={drawer}
      />
    </Paper>
  );
}
